import React from "react";
import { UseFormRegisterReturn } from "react-hook-form";

interface InputFieldProps {
    register: UseFormRegisterReturn;
    placeholder?: string;
    type?: string;
    disabled?: boolean;
    label?: string;
    name?: string;
    className?: string;
    step?: string;
}

const InputField: React.FC<InputFieldProps> = ({
    register,
    placeholder,
    type = "text",
    disabled,
    label,
    name,
    className,
    step
}) => {
    return (
        <div className="form-group">
            {label && <label className="form-label" htmlFor={name}>{label}</label>}
            <input
                {...register}
                type={type}
                className={`form-control ${className}`}
                placeholder={placeholder}
                disabled={disabled}
                id={name}
                step={step}
            />
        </div>
    );
};

export default InputField;
